import React from 'react';

import { FormControl, FormHelperText } from 'material-ui/Form';
import TextField from 'material-ui/TextField';

const errorText = {
    display: 'flex',
    justifyContent: 'center',
    color: 'red'
};

const renderTextField = ({ input, label, className, divClassName, password, disabled, value, InputProps, meta: { touched, error }, ...custom }) => (
    <FormControl className={divClassName}>
        <TextField
            label={label}
            fullWidth={false}
            error={(touched && error && error !== '')}
            type={password ? 'password' : 'text'}
            disabled={disabled}
            className={className}
            InputProps={InputProps}
            {...input}
            {...custom}
        />
        {
            touched && error &&
            <FormHelperText style={errorText}>{error}</FormHelperText>
        }
    </FormControl>
)

export default renderTextField;


// WEBPACK FOOTER //
// ./src/helpers/RenderTextFiled.js